import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";

export const validatePhoneNumberDirective = (defaultErrorMessageResolver) => {
  "ngInject";

  defaultErrorMessageResolver.getErrorMessages().then((errorMessages) => {
    errorMessages["valdatePhoneNumber"] = "Please input a valid phone number";
  });

  return {
    require: "ngModel",
    restrict: "A",
    scope: {
      phoneCountryCode: "=",
    },
    link: (scope, element, attrs, ngModel) => {
      const phoneUtil = PhoneNumberUtil.getInstance();
      const region = scope.phoneCountryCode;
      ngModel.$parsers.unshift((value) => {
        // number needs to be an instance of `libphonenumber.PhoneNumber`
        if (value.trim() !== "") {
          // validate that the value should not include a string
          if (!/^\d+$/.test(value) || value.length === 1) {
            ngModel.$setValidity("valdatePhoneNumber", false);
            return undefined;
          }
          const number = phoneUtil.parseAndKeepRawInput(value, region);
          const isValid = phoneUtil.isValidNumberForRegion(number, region);
          ngModel.$setValidity("valdatePhoneNumber", isValid);
          return isValid ? value : undefined;
        }
        ngModel.$setValidity("valdatePhoneNumber", true);
        return value;
      });

      //   //For model -> DOM validation
      // ngModel.$formatters.unshift((value) => {
      //   // ngModel.$setValidity(
      //   //   "valdatePhoneNumber",
      //   //   blacklist.indexOf(value) === -1
      //   // );
      //   if (value.trim()) {
      //     const number = phoneUtil.parseAndKeepRawInput(value, region);
      //     return phoneUtil.format(number, PhoneNumberFormat.NATIONAL);
      //   }
      //   return value;
      // });
    },
  };
};



// WEBPACK FOOTER //
// ./src/app/common/components/intl-tel-input/validate-phone-number.directive.js